import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from 'react';
import { useContextProvider } from '../../../../../../context';
import { polygon } from 'viem/chains';
import { formatAddress } from '../../../../../../utils/formatAddres';

export const ModalContentReceive = () => {
  const [showCopiedIcon, setShowCopiedIcon] = useState(false);
  const { walletAddress } = useContextProvider();

  const onClickCopyIconHandler = () => {
    setShowCopiedIcon(true);

    if (!walletAddress) return;

    navigator.clipboard.writeText(walletAddress);
  };

  useEffect(() => {
    if (showCopiedIcon) {
      const timer = setTimeout(() => {
        setShowCopiedIcon(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showCopiedIcon]);

  return (
    <div className="flex flex-col items-center text:black dark:text-white sm:px-6 px-8 pt-3 pb-7">
      <p className="text-sm mb-4">
        Receive Tokens on your Wallet from another wallet on{' '}
        {polygon?.name}.
      </p>

      <div className="mb-4 bg-white-4 sm:h-[325px] py-6 flex flex-col items-center rounded-8">
        <p className="flex items-center gap-2 text-white mb-4">
          <div className="gap-0 overflow-hidden text-ellipsis whitespace-nowrap">
            <span>{walletAddress}</span>
          </div>
        </p>

        <div className="w-[216px] h-[216px] rounded-10 bg-white flex items-center justify-center overflow-hidden">
          <QRCodeSVG includeMargin value={walletAddress || ''} size={216} />
        </div>
        <button className="sm:hidden mt-6 px-4 py-2 border-solid hover:bg-white-4 hover:border-transparent active:bg-white-8 transition-all border-2 border-white-8 w-[200px] flex justify-center items-center gap-2 rounded-8">
          <span className="text-base ">Scan a QR Code</span>
        </button>
      </div>

      <p className="mb-[22px] flex gap-2 items-center text-sm">
        {walletAddress ? (
          <>
            {formatAddress(walletAddress)}
            {!showCopiedIcon && (
              <span
                onClick={onClickCopyIconHandler}
                className="hover:cursor-pointer"
              >
                Copy
              </span>
            )}
            {showCopiedIcon && <span>Copied</span>}
          </>
        ) : (
          'Choose your wallet'
        )}
      </p>
    </div>
  );
};
